<template>
  <v-app>
    <v-app-bar dark color="#3949AB" app></v-app-bar>
    <v-main>
      <v-container fill-height>
        <v-card
          class="mx-auto"
          min-width="100%"
          min-height="100%"
          outlined
          elevation="5"
        >
          <v-col min-height="100%"></v-col>
          <v-card-title primary-title class="justify-center">
            寮管理システム
          </v-card-title>
          <v-divider class="mx-4"></v-divider>
          <v-card-text>
            <v-row class="text-center" justify="center">
              <v-form v-model="valid" ref="form" lazy-validation>
                <v-alert v-if="error != ''" color="red" text>{{
                  this.error
                }}</v-alert>
                <v-col cols="50">
                  <v-text-field
                    label="ユーザID"
                    v-model="username"
                    :counter="10"
                    maxlength="10"
                    :rules="[GlobalRules.required,
                    GlobalRules.hanAlpha]"
                    required
                    prepend-icon="mdi-account-circle"
                  ></v-text-field>
                </v-col>
                <v-col cols="50">
                  <v-text-field
                    label="パスワード"
                    v-model="password"
                    :counter="20"
                    maxlength="20"
                    :rules="[
                      GlobalRules.required,
                      GlobalRules.hanSpec,
                      GlobalRules.more_8,
                      GlobalRules.required_lowercase,
                      GlobalRules.required_uppercase,
                      GlobalRules.required_number,
                      GlobalRules.required_spec,
                    ]"
                    required
                    v-bind:type="showPassword ? 'text' : 'password'"
                    v-bind:append-icon="
                      showPassword ? 'mdi-eye' : 'mdi-eye-off'
                    "
                    prepend-icon="mdi-lock"
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                </v-col>
                <v-card-actions>
                  <v-btn
                    color="blue"
                    outlined
                    block
                    :disabled="!valid"
                    @click="signin(username, password)"
                    >ログイン</v-btn
                  >
                </v-card-actions>
                <div v-if="$useCognito">
                  <div class="pt-8 pb-4">
                    <span>パスワードを忘れた場合。</span>
                    <router-link
                      :to="{ name: 'ResetPass', params: { title: '再発行' } }"
                      >パスワード再発行</router-link
                    >
                    <p></p>
                    <span>初回ログイン。</span>
                    <router-link
                      :to="{ name: 'ResetPass', params: { title: '発行' } }"
                      >パスワード発行</router-link
                    >
                    <p></p>
                  </div>
                </div>
              </v-form>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>

    <v-footer dark color="#3949AB" style="height: 3%" app></v-footer>
  </v-app>
</template>

<script>
export default {
  name: "Signin",

  data: () => ({
    showPassword: false,
    error: "",
    valid: false,
    username: "",
    password: "",
  }),

  methods: {
    signin(username, password) {
      //cognito認証あり
      if (this.$getUseCognito()) {
        this.$cognito
          .signin(username, password)
          .then((result) => {
            this.error = false;
            this.$store.commit("setUserSub", result.idToken.payload.sub);
            this.$store.commit("setUserToken", result.accessToken.jwtToken);
            this.callGetUser(username);
            //let path = this.$route.query.redirect;
            //this.$router.replace(path == "/" || path == undefined ? "/home" : path);
          })
          .catch((err) => {
            if (err.code == "NetworkError") {
              this.error = "ネットワークに接続してください";
            } else if (err.code == "PasswordResetRequiredException") {
              this.error =
                "「パスワード発行」のリンクからパスワードを登録してください";
            } else {
              this.error = "ログインできませんでした";
            }
          });
      }
      //cognito認証なし
      else {
        this.$authenticater.signin(username, password).then((result) => {
          //eslint-disable-line
          this.$store.commit("setUserToken", result.result);
          this.callGetUser(username);
        });
      }

      //認証なし
      //console.log(password);
      // this.callGetUser(username);
    },

    //API呼び出し
    callGetUser(userId) {
      const url = "/api/Users/" + userId;
      const bearer = "Bearer " + this.$store.getters.getUserToken;

      this.$axios
        .get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: bearer,
          },
        })
        .then((response) => {
          if (response.status == 1) {
            this.$store.commit("setUserId", response.user_id);
            this.$store.commit("setName", response.user_name);
            this.$store.commit("setUserClass", response.user_class);
            this.$store.commit("setMailAddress", response.mail_address);
            // 追加
            this.$store.commit("setLocalBuildId", response.building_id);
            this.$store.commit("setLocalBuildGroupId", response.build_group_id);
            this.replace();
          } else {
            if (this.$getUseCognito()) {
              this.$cognito.signout();
            }
            setTimeout(this.resetStorage, 2000);
            this.error = "ログインできませんでした";
          }
        })
        .catch((err) => {
          //eslint-disable-line
          if (this.$getUseCognito()) {
            this.$cognito.signout();
          }
          setTimeout(this.resetStorage, 2000);
          this.error = "ログインできませんでした";
        });
    },

    replace() {
      let path = this.$route.query.redirect;
      this.$router.replace(path == "/" || path == undefined ? "/home" : path);
    },

    resetStorage() {
      this.$store.commit("resetState");
      this.$router.go(this.$router.currentRoute.path);
    },
  },
};
</script>
